import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 28px;
    width: 100%;
    min-width: 0;
    align-items: center;

    /* Espaço extra acima do primeiro formulário (abaixo das tabs) */
    & > *:first-child {
        margin-top: 12px;
        padding-top: 8px;
    }

    @media (min-width: 576px) {
        gap: 40px;

        & > *:first-child {
            margin-top: 16px;
            padding-top: 12px;
        }
    }

    @media (min-width: 768px) {
        gap: 56px;

        & > *:first-child {
            margin-top: 20px;
            padding-top: 16px;
        }
    }

    /* Reforço nos inputs (sem card à volta — herda fundo da página) */
    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }
`;

/** Centraliza o formulário na página (largura máx. confortável) */
export const CalcFormCenter = styled.div`
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    & > * {
        width: 100%;
    }
`;

export const CalcSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    align-items: center;
`;

export const CalcFieldRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px 12px;
    width: 100%;

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        flex-wrap: nowrap;
        gap: 12px;
    }

    /* Desktop: 2º formulário em uma linha com scroll se necessário */
    ${(p) =>
        p.$nowrap &&
        `
        @media (min-width: 768px) {
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        max-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        padding-bottom: 8px;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: rgba(242, 146, 5, 0.35) transparent;

        &::-webkit-scrollbar {
            height: 6px;
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(242, 146, 5, 0.35);
            border-radius: 4px;
        }
        }
    `}
`;

export const CalcLabel = styled.span`
    color: rgba(230, 235, 250, 0.92);
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.35;
    min-height: 28px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;

    ${(p) =>
        p.$nowrap &&
        `
        @media (min-width: 768px) {
        white-space: nowrap;
        }
    `}
`;

export const CalcInputWrap = styled.div`
    ${(p) =>
        p.$variant === 'percent'
            ? `
        flex: 0 0 auto;
        width: 112px;
        min-width: 100px;
        max-width: 120px;
    `
            : p.$compact
              ? `
        flex: 1 1 120px;
        width: 148px;
        min-width: 118px;
        max-width: 168px;
    `
              : `
        flex: 0 0 auto;
        width: 176px;
        min-width: 140px;
        max-width: 200px;
    `}

    @media (max-width: 767px) {
        flex: 1 1 auto !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;
    }

    .MuiFormControl-root {
        width: 100%;
    }
`;

/** Imediatamente após o último input — mesma altura dos campos (FormWrapper 48/52/56px) */
export const CalcButtonWrap = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
    align-self: center;

    @media (max-width: 767px) {
        width: 100%;
        align-self: stretch;

        .MuiButton-root {
            width: 100% !important;
            min-height: 44px !important;
            height: 44px !important;
            padding: 10px 18px !important;
        }
    }

    .MuiButton-root {
        min-height: 48px !important;
        height: 48px !important;
        padding: 0 22px !important;
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    @media (min-width: 768px) {
        .MuiButton-root {
            min-height: 52px !important;
            height: 52px !important;
        }
    }

    @media (min-width: 992px) {
        .MuiButton-root {
            min-height: 56px !important;
            height: 56px !important;
        }
    }
`;

/** Resultado: rótulo em cima + “visor” destacado para o valor */
export const CalcResultBox = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin: 0 auto;
    padding: 14px 18px 16px;
    border-radius: 14px;
    background: linear-gradient(
        165deg,
        rgba(12, 18, 32, 0.65) 0%,
        rgba(0, 0, 0, 0.4) 100%
    );
    border: 1px solid rgba(242, 146, 5, 0.28);
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.06);

    .calc-result-label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: rgba(150, 170, 210, 0.75);
        text-align: center;
    }

    .calc-result-value {
        min-height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 16px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.45);
        border: 1px solid rgba(242, 146, 5, 0.22);
        box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.35);
        font-size: clamp(1.15rem, 2.8vw, 1.5rem);
        font-weight: 800;
        letter-spacing: 0.03em;
        font-variant-numeric: tabular-nums;
        color: #ffc078;
        line-height: 1.25;
        text-align: center;
        word-break: break-word;
    }

    .calc-result-value.is-placeholder {
        color: rgba(242, 146, 5, 0.35);
        font-weight: 600;
    }
`;

export const CalcDivider = styled.hr`
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin: 0 auto;
    width: 100%;
    max-width: 680px;
    flex-shrink: 0;
`;

export const calcPrimaryButtonStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 22px',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: 14,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.35)',
    minWidth: 120,
    textTransform: 'none',
    transition: 'all 0.25s ease',
};
